import React from 'react';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import Pagination from 'material-ui-flat-pagination';

import { connect } from 'react-redux';

import VideoRotationCard from './VideoRotationCard';
import Loading from '../../../components/Loading/Loading';
import axios from '../../../axios';

class VideoRotation extends React.Component {
    state = {
        videos: [],
        loading: false,
        error: null,
        pagination: {
            page: 1,
            limit: 100,
            total: 0,
            offset: 0
        }
    };

    componentDidMount() {
        if (this.props.activeDomain.id !== null) {
            this.fetchVideos();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeDomain.id !== null && this.props.activeDomain.id !== prevProps.activeDomain.id) {
            this.fetchVideos();
        }
    }

    fetchVideos = (page = 1) => {
        this.setState({ loading: true });

        axios.defaults.headers.common['Authorization'] = this.props.token;

        axios.post('/video/getAvailableFromOtherSites', {
            domainID: this.props.activeDomain.id,
            page: page,
            limit: this.state.pagination.limit
        })
        .then(response => {
            this.setState({
                videos: response.data.videos,
                loading: false,
                pagination: {
                    ...this.state.pagination,
                    page: response.data.pagination.page,
                    total: response.data.pagination.total,
                    offset: (response.data.pagination.page - 1) * this.state.pagination.limit
                }
            });
        })
        .catch(err => {
            const msg = err.response?.data?.message || 'Videolar yüklenirken bir hata oluştu.';
            this.setState({
                error: msg,
                loading: false
            });
        });
    };

    handlePageChange = (offset) => {
        const page = Math.floor(offset / this.state.pagination.limit) + 1;
        this.setState({
            pagination: {
                ...this.state.pagination,
                offset: offset
            }
        });
        this.fetchVideos(page);
    };

    errorCloseHandler = () => {
        this.setState({ error: null });
    };

    render() {
        const { videos, loading, error, pagination } = this.state;
        const { token, activeDomain } = this.props;

        let videoCards = videos.map((video, index) => (
            <VideoRotationCard
                key={video.sourceUrl + index}
                video={video}
                token={token}
                domainID={activeDomain.id}
            />
        ));

        if (videos.length < 1 && !loading) {
            videoCards = (
                <h2 style={{ textAlign: 'center', display: 'block', width: '100%' }}>
                    Eklenebilecek video bulunamadı.
                </h2>
            );
        }

        const loadingSpinner = loading ? <Loading size={100} /> : null;

        let errorSnackbar = null;
        if (error) {
            errorSnackbar = (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                    open={error !== null}
                    autoHideDuration={5000}
                    onClose={this.errorCloseHandler}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                        className: 'snackbar danger'
                    }}
                    message={<span id="message-id">{error}</span>}
                />
            );
        }

        return (
            <React.Fragment>
                {loadingSpinner}
                {errorSnackbar}

                <div className="VideoRotationHeader">
                    <h3>
                        Diğer Sitelerdeki Videolar
                        {pagination.total > 0 && (
                            <span className="TotalCount"> ({pagination.total} video)</span>
                        )}
                    </h3>
                </div>

                <Grid container className="Videos VideoRotationList" spacing={24}>
                    {videoCards}
                </Grid>

                {pagination.total > pagination.limit && (
                    <Pagination
                        size="large"
                        limit={pagination.limit}
                        offset={pagination.offset}
                        total={pagination.total}
                        onClick={(e, offset) => this.handlePageChange(offset)}
                        classes={{
                            root: 'paginationLists'
                        }}
                    />
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    activeDomain: state.domain.activeDomain,
    token: state.auth.token
});

export default connect(mapStateToProps)(VideoRotation);
